import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  Box,
  Divider,
} from "@mui/material";

const PaymentRestrictionsDialog = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      keepMounted
      aria-labelledby="payment-restriction-dialog"
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          overflow: "visible",
          maxWidth: "500px",
        },
      }}
    >
      <DialogTitle sx={{ display: "flex", justifyContent: "flex-end" }}>
        <div
          onClick={onClose}
          style={{
            cursor: "pointer",
            border: "1.5px solid #f06292",
            borderRadius: "50%",
            height: 24,
            width: 24,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#f06292",
            fontSize: 13,
            fontWeight: "bold",
          }}
        >
          ✕
        </div>
      </DialogTitle>
      <DialogContent className="pb-10 px-10">
        <Box
          sx={{
            mx: "auto",
            width: 50,
            height: 50,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(185,49,96,0.12)",
            color: "#b93160",
          }}
        >
          <i className="tabler-lock" style={{ fontSize: 30 }} />
        </Box>

        <Typography variant="h5" className="text-center" sx={{ mt: 5 }}>
          Extended License Required
        </Typography>
        <Typography variant="body1" className="text-center" sx={{ mt: 5 }}>
          If you want to charge end users by any way, you are required to
          purchase an Extended License as per CodeCanyon/Envato policy.
        </Typography>
        <Divider sx={{ my: 5 }} />

        <Typography variant="body1" className="text-center mb-4">
          Contact us to upgrade license
        </Typography>
        <Box className="flex justify-center mt-4 flex-col items-center">
          <Button
            variant="contained"
            color="primary"
            className="flex gap-3"
            onClick={() =>
              window.open("https://wa.me/+919909515320", "_blank")
            }
          >
            <i className="tabler-message" /> +91 9909515320
          </Button>

          <a
            href="https://codecanyon.net/licenses/faq#main-differences-licenses-a"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 mt-4 text-primary"
          >
            <Typography variant="body1" className="text-primary">
              {" "}
              View Envato License Policy
            </Typography>
            <i className="tabler-external-link" />
          </a>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentRestrictionsDialog;

